import { AuthHttpHeaderService, BadRequestHandler, BaseSiteService, ForbiddenHandler, HttpErrorHandler, InternalServerErrorHandler, OccEndpointsService } from "@spartacus/core";
import { CartAdapter, CartEntryAdapter, CartValidationAdapter, CartValidationConnector, CartValidationService, CartVoucherAdapter, CartVoucherService, ProductImportInfoService, SelectiveCartService } from "@spartacus/cart/base/core";
import { GenMultiCartService } from "../features/cart/core/facade/multi-cart.service";
import { GenCartEntryAdapter } from "../features/cart/core/connectors/entry/cart-entry.adapter";
import { GenOccCartEntryAdapter } from "../features/cart/occ/occ-cart-entry.adapter";
import { LaunchDialogService, LoginGuard, LogoutGuard, ProductFacetService, ProductListComponentService } from "@spartacus/storefront";
import { CartNotEmptyGuard } from "@spartacus/checkout/base/components";
import { GenForbiddenHandler } from "../interceptors/forbidden.handler";
import { GenBadRequestHandler } from "../interceptors/bad-request.handler";
import { GenLaunchDialogService } from "../services/launch-dialog.service";
import { GenProductFacetService } from "../services/product-facet.service";
import { GenProductImportInfoService } from "../services/product-import-info.service";
import { GenProductListComponentService } from "../services/product-list-component.service";
import { GenLogoutGuard } from "../guards/logout.guard";
import { ORDER_NORMALIZER } from "@spartacus/order/root";
import { GenOccOrderNormalizer } from "../normalizers/occ-order-normalizer";
import { OccCartNormalizer, OrderEntryPromotionsNormalizer, OccCartEntryAdapter, OccCartValidationAdapter, OccCartVoucherAdapter } from "@spartacus/cart/base/occ";
import { ActiveCartFacade, CartValidationFacade, CartVoucherFacade, MultiCartFacade, ORDER_ENTRY_PROMOTIONS_NORMALIZER, SelectiveCartFacade } from "@spartacus/cart/base/root";
import { GenCartAdapter } from "../features/cart/core/connectors/cart/cart.adapter";
import { GenOccCartNormalizer } from "../features/cart/occ/occ-cart-normalizer";
import { GenOccCartAdapter } from "../features/cart/occ/occ-cart.adapter";
import { GenActiveCartService } from "../features/cart/core/facade/active-cart.service";
import { BadCartRequestHandler } from "../features/cart/core/http-interceptors/handlers/bad-cart-request.handler";
import { GenActiveCartFacade } from "../features/cart/core/facade/active-cart.facade";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { GenNotificationResponseInterceptor } from "../interceptors/notifications-response.interceptor";
import { GenAuthHttpHeaderService } from "../services/auth-http-header.service";
import { GenBaseSiteService } from "../services/base-site.service";
import { GenOccEndpointsService } from "../services/occ-endpoints.service";
import { SavedCartFacade } from "@spartacus/cart/saved-cart/root";
import { GenSavedCartService } from "../features/saved-cart/core/facade/saved-cart.service";
import { GenSavedCartFacade } from "../features/saved-cart/root/facade/saved-cart.facade";
import { GenOccSavedCartAdapter } from "../features/saved-cart/occ/adapters/occ-saved-cart.adapter";
import { GenSavedCartAdapter } from "../features/saved-cart/core/connectors/saved-cart.adapter";
import { GenLoginGuard } from "../guards/login.guard";
import { GenInternalServerErrorHandler } from "../interceptors/internal-server.handler";
import { GenCartNotEmptyGuard } from "../guards/cart-not-empty.guard";

export const providersConfig = [
  {
    provide: GenOccCartAdapter,
  },
  {
    provide: CartAdapter,
    useExisting: GenOccCartAdapter,
    multi: true,
  },
  {
    provide: GenCartAdapter,
    useClass: GenOccCartAdapter,
  },
  {
    provide: OccCartNormalizer,
    useExisting: GenOccCartNormalizer,
  },
  {
    provide: ORDER_ENTRY_PROMOTIONS_NORMALIZER,
    useExisting: OrderEntryPromotionsNormalizer,
    multi: true,
  },
  {
    provide: GenCartEntryAdapter,
    useClass: GenOccCartEntryAdapter,
  },
  {
    provide: CartEntryAdapter,
    useExisting: GenCartEntryAdapter,
    multi: true,
  },
  {
    provide: OccCartEntryAdapter,
    useExisting: GenOccCartEntryAdapter,
    multi: true,
  },
  {
    provide: CartVoucherAdapter,
    useClass: OccCartVoucherAdapter,
  },
  {
    provide: CartValidationAdapter,
    useClass: OccCartValidationAdapter,
  },
  {
    provide: LaunchDialogService,
    useExisting: GenLaunchDialogService,
  },
  {
    provide: ProductImportInfoService,
    useExisting: GenProductImportInfoService,
  },
  {
    provide: ProductFacetService,
    useExisting: GenProductFacetService,
  },
  {
    provide: ProductListComponentService,
    useExisting: GenProductListComponentService,
  },
  {
    provide: BadRequestHandler,
    useExisting: GenBadRequestHandler,
  },
  {
    provide: ForbiddenHandler,
    useExisting: GenForbiddenHandler,
  },
  {
    provide: LogoutGuard,
    useClass: GenLogoutGuard,
  },
  {
    provide: LoginGuard,
    useClass: GenLoginGuard,
  },
  {
    provide: ORDER_NORMALIZER,
    useExisting: GenOccOrderNormalizer,
    multi: true,
  },
  CartValidationConnector,
  GenActiveCartService,
  {
    provide: ActiveCartFacade,
    useExisting: GenActiveCartService,
  },
  {
    provide: GenActiveCartFacade,
    useExisting: GenActiveCartService,
  },
  {
    provide: HttpErrorHandler,
    useExisting: BadCartRequestHandler,
    multi: true,
  },
  CartVoucherService,
  {
    provide: CartVoucherFacade,
    useExisting: CartVoucherService,
  },
  GenMultiCartService,
  {
    provide: MultiCartFacade,
    useExisting: GenMultiCartService,
  },
  SelectiveCartService,
  {
    provide: SelectiveCartFacade,
    useExisting: SelectiveCartService,
  },
  CartValidationService,
  {
    provide: CartValidationFacade,
    useExisting: CartValidationService,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: GenNotificationResponseInterceptor,
    multi: true,
  },
  {
    provide: AuthHttpHeaderService,
    useClass: GenAuthHttpHeaderService,
  },
  {
    provide: BaseSiteService,
    useClass: GenBaseSiteService,
  },
  {
    provide: OccEndpointsService,
    useClass: GenOccEndpointsService,
  },
  GenSavedCartService,
  {
    provide: SavedCartFacade,
    useExisting: GenSavedCartService,
  },
  {
    provide: GenSavedCartFacade,
    useExisting: GenSavedCartService,
  },
  {
    provide: GenSavedCartAdapter,
    useClass: GenOccSavedCartAdapter,
  },
  {
    provide: InternalServerErrorHandler,
    useExisting: GenInternalServerErrorHandler,
  },
  {
    provide: CartNotEmptyGuard,
    useExisting: GenCartNotEmptyGuard,
  },
];
